import React, {CSSProperties, ReactNode, useContext} from 'react'

import {field} from './styles.js'

// Controls that are shorter than a field (buttons, checks, toggles) and centre themselves on the first line of
// fields when they sit directly in a FormRow. FormRow only tells these components that they are in a row, so a
// button in a popover or a nested layout of a field in the row isn't moved.
const fieldRowControls = new WeakSet<object>()

/** Marks a component as a short control that centres itself next to fields in a FormRow, returns the component */
export const markFieldRowControl = <T extends object>(component: T): T => {
    fieldRowControls.add(component)
    return component
}

export const isFieldRowControl = (type: unknown): boolean => {
    return (typeof type === 'function' || (typeof type === 'object' && type !== null)) && fieldRowControls.has(type as object)
}

/** True for a marked control directly in a FormRow whose items are aligned at the top */
const FormRowContext = React.createContext(false)

/** Gives the components inside a control (a label, the buttons of a SplitButton) no offset of their own */
export const FieldRowReset = ({children}: {children?: ReactNode}) => {
    return <FormRowContext.Provider value={false}>{children}</FormRowContext.Provider>
}

/** Style that centres a control of the given height on a field, when it sits at the top of a FormRow */
export const getFieldRowOffset = (inTopAlignedRow: boolean, height: number): CSSProperties => {
    return inTopAlignedRow ? {marginTop: (field.height - height) / 2} : {}
}

/** Style that centres a control of the given height on a field, when it sits at the top of a FormRow */
export const useFieldRowOffset = (height: number): CSSProperties => {
    return getFieldRowOffset(useContext(FormRowContext), height)
}

export default FormRowContext
